/* 🤖 this file was generated by svg-to-ts */
export const matIconMobileOff: {
  name: 'mobile-off';
  data: string;
} = {
  name: 'mobile-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 5v8.61l2 2V3c0-1.1-.9-2-2-2H7c-.71 0-1.33.37-1.68.93L8.39 5H17zM1.49 3.76 5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75l1.72 1.72 1.41-1.41L2.9 2.35 1.49 3.76zM7 9.27 16.73 19H7V9.27z"/></svg>`
};
